export type AliasRoute = {
  kind: 'quest' | 'activity';
  slug: string;
  rest: string;
};

export type AliasResolution = {
  routeBySlugAlias?: {
    slug: string;
    territory?: { slug?: string | null } | null;
    routeManagers?: {
      nodes: Array<{ community?: { slug?: string | null } | null }>;
    } | null;
  } | null;
  eventCourseBySlugAlias?: {
    slug: string;
    isCourse?: boolean | null;
    isProduct?: boolean | null;
    communityByOrganizerCommunity?: { slug?: string | null } | null;
  } | null;
};

export const replaceDashboardSlug = (pathname: string, slug: string): string => (
  pathname.replace(/[^/]+(?=\/dashboard\/?$)/, slug)
);

export const aliasRouteFromPath = (pathname: string): AliasRoute | null => {
  const questMatch = pathname.match(/^\/(?:community\/[^/]+\/|commons\/[^/]+\/)?(?:quest|route)\/([^/]+)(\/.*)?$/);
  const isReservedQuestPath = questMatch
    && (pathname.startsWith('/community/') || pathname.startsWith('/commons/'))
    && (questMatch[1] === 'new' || questMatch[1] === 'edit');
  if (questMatch && !isReservedQuestPath) {
    return { kind: 'quest', slug: questMatch[1], rest: questMatch[2] || '' };
  }

  const activityMatch = pathname.match(/^\/(?:event|course)\/([^/]+)(\/.*)?$/)
    || pathname.match(/^\/community\/[^/]+\/product\/([^/]+)(\/.*)?$/);
  if (activityMatch) {
    return { kind: 'activity', slug: activityMatch[1], rest: activityMatch[2] || '' };
  }

  return null;
};

export const canonicalPublicPath = (
  route: AliasRoute,
  resolution?: AliasResolution,
): string | null => {
  if (route.kind === 'quest') {
    const quest = resolution?.routeBySlugAlias;
    if (!quest) return null;

    const communitySlug = quest.routeManagers?.nodes.find(({ community }) => community?.slug)?.community?.slug;
    // Community Quest routes expose the public detail and dashboard pages.
    // Play, stop, and review suffixes are available on the generic Quest route.
    if (route.rest && route.rest !== '/dashboard') {
      return `/quest/${quest.slug}`;
    }
    if (communitySlug) return `/community/${communitySlug}/quest/${quest.slug}`;
    if (quest.territory?.slug) return `/commons/${quest.territory.slug}/quest/${quest.slug}`;
    return `/quest/${quest.slug}`;
  }

  const activity = resolution?.eventCourseBySlugAlias;
  if (!activity) return null;
  if (activity.isProduct) {
    const communitySlug = activity.communityByOrganizerCommunity?.slug;
    return communitySlug ? `/community/${communitySlug}/product/${activity.slug}` : null;
  }
  return `/${activity.isCourse ? 'course' : 'event'}/${activity.slug}`;
};
